import React, {useState, useEffect, useRef, useContext} from 'react'
import styled from 'styled-components';
import {UserContext } from '../../context/context';
import { Link } from 'react-router-dom';
// import '../SignIn/SignIn.scss'
// import './Profile.scss'

function Message() {

  // resume가 두개 이상일떄
  // awards는 input이 여러개 추가되는 형식, 이 추가되는 형식은 school이랑 work에서도
  // school, work 여러개일떄 쪼개서 어레이에 넣고 하기

  const [state, actions] = useContext(UserContext);
  const [userList, setUserList] = useState([])
  const [userEmail, setUserEmail] = useState([])
  const [userRealname, setUserRealname] = useState([])

  const [messages, setMessages] = useState()
  const [userMessage, setUserMessage] = useState()

  const [tempSend, setTempSend] = useState()

  const [tempMessage, setTempMessage] = useState()


  const [divnum, setDivnum] = useState()

  const pagebottom = useRef(null)


  let user = JSON.parse(String(localStorage.getItem('user')))
  let email = String(localStorage.getItem('email'))
  const header = {Authorization: `JWT ${user.token}`}

  let margintop = "0px"
  if(window.location.pathname.split('/')[1] === "messages")
    margintop = "45px"

  const [wrapperMargintop, setWrapperMargintop] = useState(margintop)



  useEffect(()=>{

    
    if(window.location.pathname.split('/')[1] === "messages")
      setWrapperMargintop("45px")
    else setWrapperMargintop("0px")

    if (pagebottom.current) {
      console.log("ref", pagebottom)
      pagebottom.current.addEventListener('DOMNodeInserted', event => {
        const { currentTarget: target } = event;
        target.scroll({ top: target.scrollHeight});
      });
    }

    async function fetchMessage(){
      fetch(state.awslink + "/user/messages/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log("messgeget", json)
        // console.log(email)
        // setMessages(json)
        // let temp_userList = []
        // let temp_useremaillist = []
        // let temp_userrealnamelist = []
        
        json.map((item,i)=>{
          if (item.author_to !== user.user["pk"]) {
            // console.log(item)
            // console.log(userList.filter(subitem=>subitem === item.author_to).length)
            if(userList.filter(subitem=>subitem === item.author_to).length === 0){
              setUserList(oldArray => [...oldArray, item.author_to])
              setUserEmail(oldArray => [...oldArray, item.author_to__email])
              setUserRealname(oldArray => [...oldArray, item.author_to__realname])
            }
          }
        })
      })
    }

    fetchMessage();    
  }, [userMessage])

  function fetchMessageSingle(from){
    fetch(state.awslink + "/user/messages/?from=" + from, {
      method: 'GET',
      headers: header,
    })
    .then(res=>res.json())
    .then(json=>{
      console.log(json, json.reverse())
      
      setUserMessage(json.reverse())
    })
  }

  function fetchPostMessage(){
    fetch(state.awslink + "/user/messages/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "author": email,
        "author_to": userMessage[0].author_to.email === email ? userMessage[0].author.email : userMessage[0].author_to.email,
        "content": tempSend,
      })
    })
    .then(response => response.json())
    .then(json=>{
      console.log(json)
      // setTempMessage()
      setTempSend()
      setUserMessage(json)
    })
  }
  // console.log(user.user.pk, userList, userMessage)
  // console.log(tempSend, tempMessage)
  // console.log(messages.filter(item => item.author.email==="mashi79513@yonsei.ac.kr" || item.author_to.email==="mashi79513@yonsei.ac.kr"))
  return(
    <>
        {state.width < state.breakpoint ? 
            null
            :   
            <Wrapper style={{marginTop: wrapperMargintop}}>
                <MidWrapper>
                    <LeftWrapper>
                      <div>
                        {userList.length?
                        userList.map((mUser, i)=>{
                          if(mUser !== user.user["pk"])
                          return(
                            <>
                            <Link
                              onClick={()=>{setDivnum(i); 
                                fetchMessageSingle(mUser)
                                // setUserMessage(messages.filter(item => item.author.id===mUser || item.author_to.id===mUser))
                              }}
                              className={divnum===i ? "selected-a": "nonselected-a"} 
                            >
                              <div >
                                {userRealname[i] ? userRealname[i] : "이름없음"}
                              </div>
                            </Link>
                            </>
                          )
                        })
                        
                        : null
                        }
                      
                      </div>
                    </LeftWrapper>


                    <RightWrapper>
                      {userMessage?
                        <>
                        <div className={"message-header"}>
                          {userRealname[divnum] ? userRealname[divnum] : "이름없음"}
                          &nbsp;&nbsp;
                          {userEmail[divnum]}
                        </div>

                        <div ref={pagebottom}>
                          {userMessage.map((item, i)=>{
                            if(item.author_to.id === user.user.pk){
                              // console.log("내가보낸거아님")
                              return(
                                <div style={{justifyContent: "flex-start"}}>
                                  <div>{item.content}</div> <span>{item.created_at.split('T')[0]} {item.created_at.split('T')[1].split('.')[0]}</span> 
                                </div>
                              )
                            }
                            else if(item.author.id === user.user.pk){
                              // console.log("내가보낸거")
                              return(
                                <div style={{justifyContent: "flex-end"}}>
                                  <span>{item.created_at.split('T')[0]} {item.created_at.split('T')[1].split('.')[0]}</span> <div>{item.content}</div>
                                  
                                </div>
                              )
                            }
                            
                          })}

                          {/* {tempMessage?
                              <div style={{justifyContent: "flex-end"}}>
                                  <span>방금</span> <div>{tempMessage}</div>
                                </div>
                            
                            : null
                          } */}
                        </div>

                        <div>
                          <div><input value={tempSend} onChange={(e)=> setTempSend(e.target.value)}/></div>
                          <div><button onClick={()=>{fetchPostMessage(); setTempSend('')}}>SEND</button></div>
                        </div>
                        </>
                      : 
                        <>
                          <div className={"message-header"}></div>
                          <div ref={pagebottom}></div>
                          <div></div>
                        </>}
                    </RightWrapper>
                </MidWrapper>
            </Wrapper>   
        }
    </>
  )
}

export default Message;

const Wrapper = styled.div`
  display: flex;
  
  width: 100vw;
  height: calc(100vh - 45px);

  margin-top: 45px;


  justify-content: center;
  align-items: center;

  /* border: green solid; */
  background-color: whitesmoke;
`
const MidWrapper = styled.div`
  display: flex;
  width: 90%;
  max-width: 1060px;
  height: 100%;
  justify-content: center;
  align-items: flex-start;

  background-color: whitesmoke;

  flex-direction: row;
`


const LeftWrapper = styled.div`
    display: flex;
    width: 29%;
    margin-right: 1%;
    min-height: 90%;
    height: 90%;

    margin-top: 20px;

    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    background-color: rgba(255,255,255,1);

    z-index: 2;
    box-sizing: border-box;
    border: .5px solid rgba(0,0,0,0.2);
    border-radius: 5px;
    
    position: relative;

    


    .raboard-header{
      display: flex;
      align-items: center;

      width: 100%;
      height: 70px;

      padding: 15px;
      box-sizing: border-box;
      margin: 0;
      border-radius: 5px 5px 0px 0px;
      border-bottom: .5px solid rgba(0,0,0,0.2);
      position: sticky;
      top: 0;

      overflow-y: hidden;
      z-index: 2;

      background-color: rgba(255,255,255,1);
      /* -webkit-backdrop-filter: saturate(180%) blur(20px);
      backdrop-filter: saturate(180%) blur(20px); */
      h4{
        text-align: left;
        display: block;
        width: 100%;
        /* padding: 15px; */
        /* box-sizing: border-box; */
        margin: 0;
        /* padding-top: 20px; */
        /* padding-bottom: 20px; */
      }
    }

    overflow-y: auto;
    >div{
      display: block;
      width: 100%;
      
      position: relative;
      
      .selected-a, .nonselected-a{
        width: 100%;
        height: 50px;
        opacity: 1;
        cursor: pointer;

        text-decoration: none;
        color: black;

        text-align: left;

        box-sizing: border-box;
        padding: 5px;
        padding-left: 15px;
        display: flex;
        align-items: center;
        font-size: .95rem;
        transition: .2s;
        
        :hover{
          background-color: rgba(0,0,0,0.05);
        }

        .allnum{
          position: absolute;

          font-size: 0.8rem;
          right: 20px;
          
          text-align: center;
          width: 20px;
          height: 20px;
          border-radius: 3px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(0,0,0,0.1);
          opacity: .8;
        }
      }
      .selected-a{
        background-color: rgba(0,0,0,0.1);
      }
      .nonselected-a{
        background-color: rgba(0,0,0,0);
      }
    }
    

`


const RightWrapper = styled.div`
    display: flex;
    width: 69%;
    margin-left: 1%;
    height: 90%;
    
    /* min-height: 90%; */
    position: relative;
    margin-top: 20px;
    /* margin-left: 31%; */
    
    /* right: 0; */
    /* height: 90%; */
    
    background-color: rgba(255,255,255,1);

    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    box-sizing: border-box;
    border: .5px solid rgba(0,0,0,0.2);
    border-radius: 5px;

    

    >div{
      width: 100%;
      height: 100%;
      
      display: flex;
      flex-direction:column;
        
      :nth-child(2){
        /* border: solid 1px; */
        height: calc(100% - 50px);
        overflow: auto;
        box-sizing: border-box;
        padding-left: 20px;
        padding-right: 20px;

        >div{
          display: flex;
          align-items:center;
          justify-content: center;
          width: 100%;
          height: 50px;

          box-sizing: border-box;
          margin-top: 10px;
          margin-bottom: 10px;
          
          :first-child{
            margin-top: 65px;
          }

          >div{
            border: rgba(0,0,0,0.4) solid .5px;
            border-radius: 10px;
            min-width: 50px;
            max-width: 300px;
            padding: 5px;
            
          }
          >span{
            margin-left: 5px;
            margin-right: 5px;
            font-size: .85rem;
            color: rgba(0,0,0,0.8);
          }
          
        }
      }
      :last-child{
        /* align-items:flex-end;
          justify-content: flex-end; */
        border-top: .5px solid rgba(0,0,0,0.2);
        box-sizing: border-box;
        height: 50px;
        position:absolute;
        bottom: 0;
        flex-direction: row;
        >div{
          :first-child{
            display: flex;
            align-items:center;
            justify-content: center;
            width: 90%;
            height: 50px;
            >input{
              width: 90%;
              height: 30px;
            }
          }
          :last-child{
            display: flex;
            align-items:center;
            justify-content: center;
            width: 10%;
            >button{
              height: 30px;
            }
          }
        }

      }

      
      
    }

    .message-header{
        position: absolute;
        top: 0;
        align-items:flex-start;
        justify-content: center;
        height: 50px;
        border-bottom: .5px solid rgba(0,0,0,0.2);
        box-sizing: border-box;
        padding: 20px;
        background-color: rgba(0, 0, 0, .8);
        color: white;
        backdrop-filter: saturate(180%) blur(20px);
        border-radius: 5px 5px 0 0 ;
      }

    > span{
    /* background-color: red; */
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      margin-bottom: 30px;
      > div{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        /* flex-direction: column; */
        /* :last-child{
          position: absolute;
          left: 50%;
        } */
        
      }
    }
`